export default __webpack_public_path__ + "static/media/RituBirla.4533e59e.png";